var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CellListInstantPlayCatalog,{key:"infinite_cell_list_instant_play",attrs:{"cell-list":_setup.cellList,"thumbnail-info":_vm.thumbnailInfo,"container-class-name":_vm.containerClassName}})
}
var staticRenderFns = []

export { render, staticRenderFns }